"use client"

import { Col, Row, RowProps } from "antd"
import Title from "@/components/common/Typography/Title"
import PromotionItem from "./PromotionItem"
import Carousel from "@/components/common/Carousel"
import { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { Voucher } from "@/lib/redux/features/voucher/type"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

type PromotionsProps = RowProps & {
  productTypes?: ('FLIGHTQN' | 'FLIGHTQT' | 'HOTELQN' | 'HOTELQT' | 'ESIM')[]
  vouchers: Voucher[]
  titleLevel?: 1 | 2 | 3 | 4 | 5
}

const Promotions = ({ vouchers, productTypes, titleLevel, ...props }: PromotionsProps) => {
  const { t } = useTranslation()
  const isDesktop = useIsDesktop()
  const _vouchers = vouchers
    .filter(v => productTypes ? productTypes.includes(v.productType) : true)

  if (!_vouchers?.length) {
    return <Fragment />
  }

  return (
    <Row {...props} style={{ marginBottom: '3rem', ...props.style }}>
      <Col span={24}>
        <Row style={{ marginInline: '-0.5rem' }} justify="space-between" align="middle">
          <Col style={{ paddingInline: '0.5rem' }}>
            <Title
              level={titleLevel ?? 3}
              style={{
                margin: 0,
                marginBottom: '0.5rem'
              }}
            >
              {t("promotion.prmotions_for_you")}
            </Title>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        {isDesktop ? (
          <Row gutter={[10, 10]}>
            {_vouchers.map(v => {
              return (
                <Col
                  xl={_vouchers.length > 3 ? 8 : _vouchers.length === 1 ? 12 : (24 / _vouchers.length)}
                  md={12}
                  sm={24}
                  xs={24}
                  key={v.voucherCode}
                >
                  <PromotionItem voucher={v} />
                </Col>
              )
            })}
          </Row>
        ) : (
          <Carousel
            className="carousel-main home__promotions--list"
            options={{
              pageDots: _vouchers.length > 1,
              cellAlign: "left",
              contain: true,
              draggable: true,
              prevNextButtons: false,
              wrapAround: false,
              adaptiveHeight: true,
            }}
          >
            {_vouchers.map((v) => (
              <div
                key={v.voucherCode}
                className="flickity-container flickity-cell home__promotions--item"
              >
                <PromotionItem voucher={v} />
              </div>
            ))}
          </Carousel>
        )}
      </Col>
    </Row>
  )
}

export default Promotions
